import { ButtonLink } from '@/vibes/soul/primitives/button-link';

export function PopularCategories() {
  return (
    <div className="mt-16 border-t border-contrast-200 pt-12">
      <h2 className="mb-6 text-lg font-semibold text-foreground">Popular Categories</h2>
      <div className="grid grid-cols-2 gap-4 sm:grid-cols-5">
        <ButtonLink href="/womens-clothing" variant="tertiary" size="medium">
          Women&apos;s Clothing
        </ButtonLink>
        <ButtonLink href="/mens-clothing" variant="tertiary" size="medium">
          Men&apos;s Clothing
        </ButtonLink>
        <ButtonLink href="/homewear" variant="tertiary" size="medium">
          Homewear
        </ButtonLink>
        <ButtonLink href="/jewellery" variant="tertiary" size="medium">
          Jewellery
        </ButtonLink>
        <ButtonLink href="/winter-edit" variant="tertiary" size="medium">
          Winter Edit
        </ButtonLink>
      </div>
    </div>
  );
}
